import { render, staticRenderFns } from "./Day24.vue?vue&type=template&id=803c6c0e&"
import script from "./Day24.vue?vue&type=script&lang=js&"
export * from "./Day24.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports